import { render, staticRenderFns } from "./workplaceStatementInfo.vue?vue&type=template&id=68791ae2&scoped=true&"
import script from "./workplaceStatementInfo.vue?vue&type=script&lang=js&"
export * from "./workplaceStatementInfo.vue?vue&type=script&lang=js&"
import style0 from "./workplaceStatementInfo.vue?vue&type=style&index=0&id=68791ae2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68791ae2",
  null
  
)

export default component.exports